import { TimesheetsStoreTimesheet } from '@web/types/redux/stores/timesheets.types';

export const getTimesheetsRoute = '/timesheets';
export const getTimesheetRoute = (timesheet: Pick<TimesheetsStoreTimesheet, 'id'>, staff?: boolean): string => {
  return `/timesheet/${timesheet.id}${staff ? '?staff=true' : ''}`;
};
